import React from 'react'

const DropIcon = (props)=>(
    <svg width="8" height="14" viewBox="0 0 8 14" xmlns="http://www.w3.org/2000/svg" fill="none"><path d="M4 .624c.212 0 .416.084.566.234l3.2 3.2c.312.312.312.819 0 1.131-.312.312-.819.312-1.131 0l-2.634-2.634-2.634 2.634c-.312.312-.819.312-1.131 0-.312-.312-.312-.819 0-1.131l3.2-3.2c.15-.15.354-.234.566-.234zm-3.766 8.234c.312-.312.819-.312 1.131 0l2.634 2.634 2.634-2.634c.312-.312.819-.312 1.131 0 .312.312.312.819 0 1.131l-3.2 3.2c-.312.312-.819.312-1.131 0l-3.2-3.2c-.312-.312-.312-.819 0-1.131z" fill={props.fill}/></svg>
)

export default DropIcon
